export enum Project {
  Default = 0,
  Brain = 1,
}

// general configuration of the unity app engine need to be passed to InitializeApp call
export interface UnityEngineAppConfig {
  // path to the application assets folder on S3
  basePath: string;
  // timestamp when UnityLoader was injected to oversee loading time
  startedAt: number;
  // set to 1 to enable internal logging of the engine
  enableLogging: number;
  // set to 1 to apply some Brain related differencies in appearance
  project?: Project;
  // current language
  language: string;
  // general translations map - might be added from (for example) i18next or other i18 source
  localization: any;
  // common assets that may be downloaded after start
  bundles: any[];
  // set to 1 to hide the "quit" button in the pause menu
  showQuitButton?: number;
}
